@if (employees()) {
  <div
    class="flex h-full w-full flex-col items-center justify-between border border-neutral-90 px-5 pb-2 pt-4">
    <div class="w-full text-sm font-medium">{{ message() }}</div>
    <div class="flex w-full flex-1 flex-wrap gap-1 py-2">
      @for (employee of employees(); track employee.employeeEvaluationId) {
        <qaroni-matrix-nine-grid-box-employee [employee]="employee" />
      }
    </div>
    <div class="w-full text-end text-xl font-medium text-neutral-90">
      {{ employees().length }}
    </div>
  </div>
}
